import React from 'react';
import { connect } from 'react-redux';
import { startSetCategory } from '../actions/globalState';
import {Select} from 'antd';
const Option = Select.Option;

export class CategoryType extends React.Component {

  onCategoryChange = (value) => {
    //console.log('onCategoryChange', value)
    this.props.startSetCategory(value, this.props.type);
  };
  render() {
    //console.log('geo type component', this.props)
    return (
      <Select size="large"
        className="category"
        value={this.props.category}
        onChange={value => this.onCategoryChange(value)}
        >
        {
          this.props.categories.length === 0 ? 
          (<Option value="Total">Total</Option>) : 
          ( this.props.categories.map((item, index) => {
            return <Option key={index} value={item.category}>{item.category}</Option>
          }))
        }
      </Select>
    )
  }
}

const mapStateToProps = (state) => ({
  category: state.globalState.category,
  categories: state.globalState.categories
});

const mapDispatchToProps = (dispatch) => ({
  startSetCategory: (text, type) => dispatch(startSetCategory(text, type))
});

export default connect(mapStateToProps, mapDispatchToProps)(CategoryType);



// WEBPACK FOOTER //
// ./src/components/CategoryType.js